interface StatusBarCell {
  label: string
  value: string
}

interface StatusBarProps {
  cells: StatusBarCell[]
}

export function StatusBar({ cells }: StatusBarProps) {
  return (
    <div className="flex items-center h-5 text-[10px] font-mono text-muted-foreground select-none shrink-0 border-t border-border divide-x divide-border">
      {cells.map((cell) => (
        <div key={cell.label} className="flex-1 min-w-0 px-2 truncate text-center">
          <span className="text-muted-foreground/60">{cell.label}</span> <span>{cell.value}</span>
        </div>
      ))}
    </div>
  )
}
